import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import {Context as SalesChannelContext} from '../../contexts/SalesChannels'
import ObjectForm from '../../components/ObjectForm'

import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
const PublicityCampaignCreate = ({open, close, model, ...rest}) => {
  const app = React.useContext(AppContext)
  const { clients } = app.clients
  const SalesChannel = React.useContext(SalesChannelContext)
  const { recall, setRecall } = SalesChannel
  const { create, update, } = SalesChannel.publicityCampaigns
  const title = model?"Actualizar":"Añadir"
  const client = model? clients.find(c => c.id == model.clientId):null
  const _submit = (data) => {
    const submit = model?update:create
    submit(data)
    close()
  }
  return (
    <Dialog onClose={close} open={open}>
      <DialogTitle>{title} Costo de campaña de publicidad</DialogTitle>
      <ObjectForm ignored={['id']} recall={recall} submit={_submit}
        stc={{ vendor: app.vendor }}
        obj={{date:'', clientId:'', cost:'', description:'', }}
        labels={{date:'Fecha', clientId:'Cliente', cost:'Costo', description:'Descripcion', }}
        types={{date:'date-month',  clientId:'select', cost:'money', description:'text', }}
        options={{
          clientId:clients.map(c => {return{value:c.id,label:c.name}}), 
        }}
        controlled={{cost:model?model.cost:0, date:model?model.date:null}}
        changed={{...model, clientId:client?client.id:null} || {}} 
      />
      <Button onClick={() => {setRecall(true)}}>{title}</Button>
    </Dialog>
  )
}
export default PublicityCampaignCreate